// src/Config/getViewConfig.js
import { INDUSTRY_TEMPLATES } from "./industryTemplates";
import { getProductConfig } from "./getProductConfig";

 
export const getViewConfig = (product) => {
    if (!product) return INDUSTRY_TEMPLATES.default;

    const subcategorySlug =
        product.subcategory_details?.slug?.toLowerCase() ||
        product.subcategory?.slug?.toLowerCase();

    // Aapki existing getProductConfig use karo
    const config = getProductConfig(subcategorySlug);

    return config;
};